module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/vi/6-7a457381e5cae7d017a00576844acd3c.jpg";